import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import s from './Pill.module.css';

/** The status palette keys (`P` in the design logic). */
export type Tone = 'ok' | 'warn' | 'err' | 'acc' | 'mute';

type Props = {
  tone: Tone;
  children: ReactNode;
  /** md = 26px with dot; sm = 24px with dot (tables); tag = no dot, 11.5px; tagTight; tagMd = 12px. */
  size?: 'md' | 'sm' | 'tag' | 'tagTight' | 'tagMd';
  /** In grid cells the markup sets justify-self:start. */
  start?: boolean;
  className?: string;
  /** A tooltip (e.g. why a state is what it is). */
  title?: string;
};

export function Pill({ tone, children, size = 'md', start, className, title }: Props) {
  const tag = size === 'tag' || size === 'tagTight' || size === 'tagMd';
  return (
    <span
      className={cx(
        s.pill,
        size === 'sm' && s.sm,
        tag && (size === 'tagMd' ? s.tagMd : s.tag),
        size === 'tagTight' && s.tagTight,
        s[tone],
        start && s.start,
        className,
      )}
      title={title}
    >
      {!tag && <span className={s.dot} />}
      {children}
    </span>
  );
}

/** A bare 8px status dot (audit rows). */
export function StatusDot({ tone, className }: { tone: Tone; className?: string }) {
  return <span className={cx(s.statusDot, s[tone], className)} />;
}
